import HamburgerIcon from '../HamburgerIcon';
import { clearAdminMagicSecret } from '../../connector/auth';
import './AdminHeader.css';

interface AdminHeaderProps {
  title: string;
  onExpand?: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ title, onExpand }) => (
  <div className="adminHeader">
    {onExpand && (
      <button className="adminHeaderHamburger headerHamburger" onClick={onExpand}>
        <HamburgerIcon size={24} />
      </button>
    )}
    <h2>{title}</h2>
    <button className="adminResetSecret" onClick={() => { clearAdminMagicSecret(); window.location.reload(); }}>Reset password</button>
  </div>
);

export default AdminHeader;
